"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOkay = isOkay;
exports.flattenAll = flattenAll;
exports.createTableName = createTableName;

function isOkay(obj) {
  return obj != null;
}

function flattenAll(arr) {
  return arr.filter(function (part) {
    return isOkay(part);
  }).reduce(function (prev, cur) {
    return prev.concat(cur);
  }, []);
}

function createTableName(tableNames) {
  var returnValue = {
    type: 'identifier',
    variant: 'tableName'
  };
  Object.keys(tableNames).forEach(function (eachTableNamesKey) {
    returnValue[eachTableNamesKey] = tableNames[eachTableNamesKey];
  });
  returnValue.tableNames = Object.keys(tableNames);
  return returnValue;
}